export default __webpack_public_path__ + "assets/BB&T-f8d50b51da4ca4815fb96c8ca929cb74.svg";